import { AssigneeHandlerResponse } from 'src/pages/api/ai/selectAssignee'

import { AssigneeType } from 'types/api.graphql'

interface AssigneeInput {
  type: AssigneeType
  id: string
  name: string
}

interface GetAISelectAssigneesInput {
  allAssignees: AssigneeInput[]
  currentAssignees: AssigneeInput[]
  transcriptions: string
}

// todo - on new version of nextjs and app router, make a server action
export const getAISelectAssignees = async ({
  allAssignees,
  currentAssignees,
  transcriptions,
}: GetAISelectAssigneesInput): Promise<AssigneeHandlerResponse> => {
  const assigneeResponse = await fetch('/api/ai/selectAssignee', {
    method: 'POST',
    body: JSON.stringify({
      assignees: allAssignees,
      transcriptions,
      currentAssignees,
    }),
  })

  const assigneeData =
    (await assigneeResponse.json()) as AssigneeHandlerResponse

  return assigneeData
}
